import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const taxApi = createApi({
	reducerPath: "taxApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Tax"],

	endpoints: (builder) => ({
		getTaxs: builder.query<(bt_mtax & bt_mtaxgroup)[], void>({
			query: () => `tax/`,
			providesTags: ["Tax"],
		}),
		getTaxById: builder.query<bt_mtax, string>({
			query: (id) => `tax/byid/${id}`,
			providesTags: ["Tax"],
		}),
		insertTax: builder.mutation({
			query: (tax) => ({
				url: `/tax/`,
				method: "POST",
				body: tax,
			}),
			invalidatesTags: ["Tax"],
		}),
		updateTax: builder.mutation({
			query: (tax) => ({
				url: `/tax/`,
				method: "PUT",
				body: tax,
			}),
			invalidatesTags: ["Tax"],
		}),
		deleteTax: builder.mutation({
			query: (tax) => ({
				url: `/tax/${tax.tx_id}`,
				method: "DELETE",
				body: tax,
			}),
			invalidatesTags: ["Tax"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetTaxsQuery,
	useGetTaxByIdQuery,
	useInsertTaxMutation,
	useUpdateTaxMutation,
	useDeleteTaxMutation,
} = taxApi;
